import { IOpData, IReferenceType, IOpChangeState } from '../util/interfaces'
import { DataType } from '../../helpers/common-helper'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'

import { OpDataType } from '../core/op-data-type'

export class OpProfileData implements IOpData {
    //Properties
    public idProfileData: number
    public idProfile: number
    public idDataType: number
    public indexNbr: number
    public value: any
    //Properties end

    //NavigationProperties
    public dataType: OpDataType
    //NavigationProperties end

    constructor(opObj: any = null) {
        this.fromJSON(opObj)
    }

    //IOpData implementation
    public get idData() { return this.idProfileData }
    //get idDataType() { return this.idDataType }
    public get indexNBR() { return this.indexNbr }
    //get value() { return this.value }
    //IOpData implementation end

    public static fromIOpData(data: IOpData): OpProfileData {
        var newData: OpProfileData = new OpProfileData(null)

        newData.idProfileData = data.idData,
        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState

        return newData
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end


    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idProfileData = opObj.ID_PROFILE_DATA
            this.idProfile = opObj.ID_PROFILE
            this.idDataType = opObj.ID_DATA_TYPE
            this.indexNbr = opObj.INDEX_NBR
            this.value = opObj.VALUE

            this.dataType = opObj._DataType
        }

    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_PROFILE_DATA: this.idProfileData,
            ID_PROFILE: this.idProfile,
            ID_DATA_TYPE: this.idDataType,
            INDEX_NBR: this.indexNbr,
            VALUE: this.value,
            OpState: this.opState
        }
    }
}